import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  public data: any[];
  public messageReceived = new EventEmitter<any>();
  connectionEstablished = new EventEmitter<Boolean>();

  private connectionIsEstablished = false;
  private _hubConnection: HubConnection; 
  constructor(private http: HttpClient) {
    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();  
  }

  public createConnection() {
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(environment.apiUrl.replace('api', '') + 'message')
      .build();
  }

  public startConnection(): void {
    this._hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        console.log('Hub connection started');
        this.connectionEstablished.emit(true);
      })
      .catch(err => {
        console.log('Error while establishing connection, retrying...');
        setTimeout(function () { this.startConnection(); }, 5000);
      });
  }
  public registerOnServerEvents(): void {
    this._hubConnection.on('send', (data: any) => { 
      this.messageReceived.emit(data);
    });
  }
  public startHttpRequest = (message: string) => {
    this.http.post(environment.apiUrl + '/BroadCastMessage/message?message=' + message, "")
      .subscribe(res => {
      })
  }
  //public addTransferChartDataListener = () => {
  //  this._hubConnection.on('transferchartdata', (data) => {
  //    this.data = data;
  //    console.log(data);
  //  });
  //}
}
